const SafetyIconTruck = ({ className }: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#269D84"
    />
    <path
      d="M11.9996 25.5998C12.6361 25.5998 13.2466 25.3469 13.6967 24.8969C14.1468 24.4468 14.3996 23.8363 14.3996 23.1998C14.3996 22.5633 14.1468 21.9528 13.6967 21.5027C13.2466 21.0527 12.6361 20.7998 11.9996 20.7998C11.3631 20.7998 10.7526 21.0527 10.3026 21.5027C9.85247 21.9528 9.59961 22.5633 9.59961 23.1998C9.59961 23.8363 9.85247 24.4468 10.3026 24.8969C10.7526 25.3469 11.3631 25.5998 11.9996 25.5998ZM23.9996 25.5998C24.6361 25.5998 25.2466 25.3469 25.6967 24.8969C26.1468 24.4468 26.3996 23.8363 26.3996 23.1998C26.3996 22.5633 26.1468 21.9528 25.6967 21.5027C25.2466 21.0527 24.6361 20.7998 23.9996 20.7998C23.3631 20.7998 22.7526 21.0527 22.3026 21.5027C21.8525 21.9528 21.5996 22.5633 21.5996 23.1998C21.5996 23.8363 21.8525 24.4468 22.3026 24.8969C22.7526 25.3469 23.3631 25.5998 23.9996 25.5998Z"
      stroke="#171717"
      strokeWidth="1.5"
      strokeMiterlimit="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4 23.2V10.72C20.4 10.529 20.3241 10.3459 20.1891 10.2109C20.0541 10.0759 19.871 10 19.68 10H6.72C6.52904 10 6.34591 10.0759 6.21088 10.2109C6.07586 10.3459 6 10.529 6 10.72V22.48C6 22.5746 6.01862 22.6682 6.05481 22.7555C6.09099 22.8429 6.14402 22.9223 6.21088 22.9891C6.27774 23.056 6.35711 23.109 6.44447 23.1452C6.53182 23.1814 6.62545 23.2 6.72 23.2H9.18M20.4 23.2H14.46M20.4 23.2H21.6M20.4 13.6H27.132C27.2712 13.6 27.4074 13.6404 27.5241 13.7162C27.6408 13.792 27.733 13.9001 27.7896 14.0272L29.9376 18.8608C29.9785 18.9526 29.9998 19.0519 30 19.1524V22.48C30 22.5746 29.9814 22.6682 29.9452 22.7555C29.909 22.8429 29.856 22.9223 29.7891 22.9891C29.7223 23.056 29.6429 23.109 29.5555 23.1452C29.4682 23.1814 29.3746 23.2 29.28 23.2H27"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export default SafetyIconTruck
